<template>
    <div class="page">
        <strong>Date:</strong> {{ date }}
        <br />
        <br />
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }}
            <br />
            {{ userStore.user.dob }} | {{ userStore.user.ssn }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
            </template>
        </p>
        <p class="letter-content">
            This letter is in response to your recent claim that the account(s) listed below have been “verified” and that the
            information they are reporting under my name is accurate.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            Be advised that the description of the procedure used to determine the accuracy and completeness of the information must
            be provided within fifteen <strong>(15) days</strong> of the completion of your investigation.
        </p>
        <p>
            Enclosed are copies of ID and proof of mailing address.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
